import { inject } from "@angular/core"
import { from, Observable } from "rxjs"
import { environment } from "src/environments/environment"
import { SecureHttp } from "./secure-http-client"

export class OrdsClient {

    private http = inject(SecureHttp)

    post(endpoint: string, body: Object): Observable<any>  {
        return this.http.post(`/python-fns/preci/${endpoint}`, body)
    }

}